module.exports = __webpack_public_path__ + "static/media/applause.ae79f22.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/applause.mp3
// module id = +S5R
// module chunks = 1